import UploadAvatar from "components/UploadAvatar/UploadAvatar";
import React, { useState } from "react";
import { Message } from "semantic-ui-react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { UserAvatar } from "../../components/Atoms/Avatar";

interface MyDetailsProps {
  changeAvatar?: boolean
  changeNameUrl?: string
  user: server.dto.UserSmall
}

const AvatarImage = (props: MyDetailsProps) => {
  const [error, setError] = useState<string | undefined>();

  const uploadAvatar = async (file: File) => {
    const res = await uploadFileToCoreApi(
      window.CoreApi.User.SetAvatar,
      window.CoreApi.User.SetAvatar.absoluteUrl(site.currentUser.userId),
      { file },
      { fileType: "image" });
    if (res.data.hasErrors) {
      setError("Could not upload image");
      return;
    }
    window.location.reload();
  };

  if (props.changeAvatar) {
    return <>
      <UploadAvatar
        avatarUrl={props.user.avatarUrl}
        onSave={uploadAvatar}
      />
      {error && <Message color="red">{error}</Message>}
    </>;
  } else {
    return (<UserAvatar user={props.user} size="avatar-80" />);
  }
};

const MyName = (props: MyDetailsProps) => {
  if (props.changeNameUrl) {
    return (<a href={props.changeNameUrl} style={{ textDecoration: "none" }}><h1 className="nav-text-semibold">{props.user.fullName}</h1></a>);
  } else {
    return (<h1 className="nav-text-semibold">{props.user.fullName}</h1>);
  }
};

const MyDetails = (props: MyDetailsProps) => {
  return <div className="my-details-header">
    <AvatarImage {...props} />
    <MyName {...props} />
  </div>;
};

export default MyDetails;